import React from 'react';
import {render} from 'react-dom';
import { Router, Link, hashHistory } from 'react-router';
import SwipeableViews from 'react-swipeable-views';

import Header from '../components/header.jsx';
import LoadingIndicator from '../components/loadingIndicator.jsx';
import Navigation from '../components/navigation.jsx';
import {Tabs, Tab} from 'material-ui/Tabs';

import Quiz from './quiz.jsx';
import ScoreSheet from './score.jsx';
import KeySheet from './key.jsx';
import Leaderboard from './leaderboard.jsx';

const QuizContainer = React.createClass({
	getInitialState: function() {
		return {
			data: {},
			headerTitle: 'Quiz',
			creator: '',
			id: 0,
			status: 'open',
			submitted: false,
			questions: [],
			guesses: [],
			loading: true,
			viewIndex: 0,
			resultData: [],
			results: [],
			selectedUser: {},
			selectedUserScore: 0
		}
	},
	componentWillReceiveProps: function(nextProps) {
		if (nextProps.params.id !== this.props.params.id) {
			this._getQuiz(nextProps.params.id);
			this.setState({
				viewIndex: 0
			});
		}
	},
	componentDidMount: function() {
		this._getQuiz(this.props.params.id);
	},
	_getResults: function(id) {
		if (!id) {
			return;
		}

		let request = new XMLHttpRequest;
		request.open('GET', '/api/v2/quizzes/' + id + '/results');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send();
		request.onreadystatechange = function() {
			if (request.status == 200 && request.readyState == 4) {
				const data = JSON.parse(request.responseText);
				const results = [];
				const scores = [];

				data.forEach(function(user){
					scores.push(user.quizScore);
				});

				function compareScore(a,b) {
					return b - a;
				}

				scores.sort(compareScore);

				data.forEach(function(user) {
					results.push({
						score: user.quizScore,
						username: user.userInfo.username,
						avatar: user.userInfo.avatar
					});
				});

				function compareNum(a,b) {
					if (a.score < b.score) {
						return 1;
					} else if (a.score > b.score) {
						return -1;
					} else {
						return 0;
					}
				}

				results.sort(compareNum);

				results.forEach(function(user) {
					for (var i = 0; i < scores.length; i++) {
						if (user.score == scores[i]) {
							user.rank = i + 1;
							break;
						}
					}
				});

				this.setState({
					resultData: data,
					results: results
				}, function(){
					this._defaultScoreSheet(localStorage.getItem('username'));
					setTimeout(function() {
						if (this.state.status != 'closed' && this.state.guesses.length) {
							this.props.selectView(3);
							this.props.setActiveQuiz(this.state.id);
							localStorage.setItem('activeQuiz', this.state.id);
						} else if (this.props.activeQuiz == -1) {
							this.props.selectView(3);
						}
					}.bind(this), 100);
				});

			}
		}.bind(this);
	},
	_getQuiz: function(id) {
		let request = new XMLHttpRequest;
		request.open('GET', '/api/v2/quizzes/' + id);
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send();
		request.onreadystatechange = function() {
			if (request.readyState == 4) {
				if (request.status == 200) {
					const quiz = JSON.parse(request.responseText);
					this.setState({
						data: quiz,
						headerTitle: quiz.name,
						creator: quiz.creator,
						id: quiz._id,
						questions: quiz.questions,
						status: quiz.status
					}, function(){
						this._getResults(this.state.id);
					});
				} else {
					hashHistory.push("/login");
				}
			}
		}.bind(this);
	},
	_updateSubmission: function() {
		this.setState({
			submitted: true
		});
	},
	_defaultScoreSheet: function(user) {
		let activePlayer = false;
		this.state.resultData.forEach(function(i) {
			if (i['user'] == user) {
				activePlayer = true;
				this.setState({
					guesses: i['guesses'],
					selectedUser: i['userInfo'],
					selectedUserScore: i['quizScore']
				}, function() {
					if (this.state.guesses.length && user == localStorage.getItem('username')) {
						this._updateSubmission();
					}
				});
			}
		}.bind(this));

		if (!activePlayer) {
			this.setState({
				guesses: [],
				selectedUser: {},
				selectedUserScore: 0
			})
		}

		this.setState({
			loading: false
		});
	},
	_switchScoreSheet: function(user) {
		this._defaultScoreSheet(user);
		setTimeout(function() {
			this._changeQuizView(1);
		}.bind(this), 50);
	},
	_updateQuestions: function(questions) {
		this.setState({
			questions: questions
		})
	},
	_changeQuizView: function(view) {
		this.setState({
			viewIndex: view
		});
	},
	render: function() {
		const style = {
			tabs: {
				marginTop: '50px',
				position: 'fixed',
				width: '100%',
				zIndex: '9',
			},
			view: {
				height: '100vh',
			},
			slide: {
				height: '100vh',
			}
		}
		if (this.props.params.id == -1) {
			return (
				<div className="view">
					<Header headerTitle='Active Quiz' />
					<p className="empty">
						Looks like you don't have an active quiz!
						<br/>
						Go to Quizzes to view all!
					</p>
					<Navigation
						selectView={this.props.selectView}
						selectedIndex={this.props.selectedIndex}
						activeQuiz={this.props.activeQuiz}
					/>
				</div>
			)
		} else if (this.state.loading) {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<LoadingIndicator />
				</div>
			)
		} else if (this.state.status == 'open' && !this.state.submitted) {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<Quiz
						id={this.state.id}
						questions={this.state.questions}
						getResults={this._getResults}
					/>
				</div>
			)
		} else if (this.state.creator === localStorage.getItem('username')) {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<Tabs
						value={this.state.viewIndex}
						onChange={this._changeQuizView}
						style={style.tabs}
					>
						<Tab label="Leaderboard" value={0} />
						<Tab label="Score Sheet"
							value={1}
							onClick={() => this._switchScoreSheet(localStorage.getItem('username'))}
						/>
						<Tab label="Key" value={2} />
					</Tabs>
					<SwipeableViews
						index={this.state.viewIndex}
						onChangeIndex={this._changeQuizView}
						animateHeight={true}
						style={style.view}
						slideStyle={style.slide}
					>
						<Leaderboard
							id={this.state.id}
							results={this.state.results}
							switchScoreSheet={this._switchScoreSheet}
							getQuiz={this._getQuiz.bind(this)}
						/>
						<ScoreSheet
							id={this.state.id}
							status={this.state.status}
							questions={this.state.questions}
							guesses={this.state.guesses}
							user={this.state.selectedUser}
							selectedUserScore={this.state.selectedUserScore}
							getQuiz={this._getQuiz.bind(this)}
						/>
						<KeySheet
							quiz={this.state.data}
							id={this.state.id}
							questions={this.state.questions}
							updateView={this._changeQuizView}
							getResults={this._getResults}
							updateQuestions={this._updateQuestions}
							defaultScoreSheet={this._defaultScoreSheet}
						/>
					</SwipeableViews>
					<Navigation
						selectView={this.props.selectView}
						selectedIndex={this.props.selectedIndex}
						activeQuiz={this.props.activeQuiz}
					/>
				</div>
			)
		} else {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<Tabs
						value={this.state.viewIndex}
						onChange={this._changeQuizView}
						style={style.tabs}
					>
						<Tab label="Leaderboard" value={0} />
						<Tab label="Score Sheet"
							value={1}
							onClick={() => this._switchScoreSheet(localStorage.getItem('username'))}
						/>
					</Tabs>
					<SwipeableViews
						index={this.state.viewIndex}
						onChangeIndex={this._changeQuizView}
						animateHeight={true}
						style={style.view}
						slideStyle={style.slide}
					>
						<Leaderboard
							id={this.state.id}
							results={this.state.results}
							switchScoreSheet={this._switchScoreSheet}
							getQuiz={this._getQuiz.bind(this)}
						/>
						<ScoreSheet
							id={this.state.id}
							status={this.state.status}
							questions={this.state.questions}
							guesses={this.state.guesses}
							user={this.state.selectedUser}
							selectedUserScore={this.state.selectedUserScore}
							getQuiz={this._getQuiz.bind(this)}
						/>
					</SwipeableViews>
					<Navigation
						selectView={this.props.selectView}
						selectedIndex={this.props.selectedIndex}
						activeQuiz={this.props.activeQuiz}
					/>
				</div>
			)
		}
	}

});

export default QuizContainer;


// WEBPACK FOOTER //
// ./src/views/quiz-container.jsx